import React from "react";

function CourierSVG({ colorCode, seaClass }) {
  return (
    <svg
      className={`MuiSvgIcon-root ${seaClass}`}
      style={{ fill: colorCode }}
      viewBox="0 0 32 20"
    >
      <g>
        <path
          d="M5.188,10.883c0.482-0.017,0.936-0.033,1.388-0.047c0.145-0.004,0.234-0.051,0.242-0.22c0.015-0.42,0.197-0.771,0.47-1.084
		c0.065-0.074,0.115-0.189,0.114-0.286C7.395,8.675,7.379,8.104,7.347,7.534C7.31,6.879,6.915,6.523,6.264,6.541
		C5.524,6.562,4.785,6.585,4.046,6.616C3.385,6.642,3.017,7.04,3.036,7.703c0.021,0.681,0.058,1.36,0.064,2.04
		c0.004,0.477,0.128,0.874,0.611,1.116"
        />
        <path
          d="M17.803,0.905c-3.846,0.004-7.692,0.002-11.537,0.003c-0.529,0-0.766,0.241-0.766,0.77C5.5,2.988,5.5,4.297,5.5,5.607
		c0,0.072,0,0.145,0,0.236c0.443,0,0.85,0,1.282,0c0-1.22,0-2.434,0-3.65c3.515,0,7.006,0,10.493,0c0,5.73,0,11.443,0,17.179
		c-0.571,0-1.124,0-1.674,0c0,0.43,0,0.836,0,1.261c0.717,0,1.416-0.016,2.115,0.006c0.391,0.012,0.678-0.108,0.853-0.464
		c0-6.261,0-12.522,0-18.783C18.428,1.051,18.175,0.904,17.803,0.905z"
        />
        <path
          d="M14.626,7.978c-0.065-0.57-0.479-0.995-1.054-1.014c-0.737-0.023-1.477-0.018-2.215,0.003
		c-0.458,0.013-0.859,0.332-0.958,0.78c-0.074,0.334-0.06,0.688-0.084,1.043c0.832,0.02,1.382-0.562,2.073-0.801
		c-0.415,0.42-0.835,0.819-1.221,1.249c-0.231,0.258-0.492,0.361-0.828,0.388C9.665,9.683,8.992,9.771,8.32,9.856
		c-0.481,0.061-0.808,0.459-0.753,0.896c0.059,0.476,0.466,0.774,0.965,0.715c0.86-0.102,1.723-0.203,2.585-0.298
		c0.299-0.033,0.552-0.142,0.765-0.36c0.394-0.403,0.8-0.794,1.197-1.194c0.153-0.154,0.297-0.317,0.445-0.476
		c0.018,0.015,0.033,0.029,0.051,0.044c-0.363,0.681-0.751,1.351-1.08,2.049c-0.232,0.492-0.588,0.699-1.109,0.722
		c-0.346,0.016-0.69,0.078-1.051,0.122c0,0.09,0,0.157,0,0.225c-0.008,2.886-0.017,5.772-0.021,8.658
		c-0.001,0.107,0.006,0.214,0.022,0.318c0.08,0.547,0.623,0.915,1.159,0.792c0.488-0.113,0.767-0.49,0.767-1.046
		c0.001-2.277,0-4.554,0-6.831c0-0.088,0-0.177,0-0.268c0.151,0,0.271,0,0.419,0c0,0.101,0,0.176,0,0.252
		c0.009,2.246,0.018,4.493,0.026,6.739c0,0.106,0,0.214,0.011,0.318c0.057,0.564,0.619,0.965,1.17,0.835
		c0.478-0.113,0.761-0.483,0.76-1.025c-0.002-4.295-0.008-8.59-0.013-12.885C14.636,8.099,14.634,8.038,14.626,7.978z"
        />
        <path
          d="M6.77,11.604c-0.162,0.007-0.306,0.029-0.447,0.016c-0.23-0.021-0.408,0.018-0.497,0.268
		c-0.033,0.095-0.135,0.164-0.188,0.254c-0.057,0.099-0.132,0.207-0.132,0.312C5.499,14.928,5.5,17.402,5.5,19.876
		c0,0.514,0.242,0.757,0.753,0.757c0.975,0.002,1.948,0.001,2.923,0c0.064,0,0.131-0.008,0.191-0.012c0-0.428,0-0.836,0-1.269
		c-0.868,0-1.724,0-2.598,0C6.77,16.757,6.77,14.187,6.77,11.604z"
        />
        <path
          d="M14.151,4.696c-0.015-0.944-0.756-1.689-1.678-1.688c-0.939,0.001-1.692,0.779-1.678,1.736
		c0.015,0.89,0.79,1.637,1.691,1.629C13.398,6.365,14.166,5.592,14.151,4.696z"
        />
      </g>
    </svg>
  );
}

export default CourierSVG;
